/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";

// Formik and Yup
import { useFormik } from "formik";
import * as Yup from "yup";
import TextError from "utils/TextError";

// Dashboard components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDCard from "components/MDCard";
import MDInput from "components/MDInput";

// Dashboard standardized components
import CreateButton from "components/standardized-components/CreateButton";

// Dashboard example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Modal from "@mui/material/Modal";
import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

import { createTheme, ThemeProvider } from "@mui/material/styles";

// Notification
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// @mui material icons
import CloseIcon from "@mui/icons-material/Close";

// Functions from store
import {
  getSubModulesByRoleId,
  createMachine,
  updateMachineCenter,
  deleteMachine,
  getMachineCenter,
  getDynamicColumn,
  createDynamicColumn,
  getPrintersForLabelCreation,
  getLocationsForMachine,
  getWorkCenter,
  updateMachineStatus,
} from "../../store";

// Cookies
import Cookies from "universal-cookie";
import EditButton from "components/standardized-components/EditButton";
import DeleteButton from "components/standardized-components/DeleteButton";
import { Backdrop, CircularProgress } from "@mui/material";
import { addMinutes, format } from "date-fns";
import Select from "react-select";
import StandardSwitch from "components/standardized-components/StandardSwitch";

const cookies = new Cookies();

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 550,
  boxShadow: 24,
  p: 0,
  pt: 3,
  height: "fit-content",
  maxHeight: "90%",
  overFlow: "auto",
};

const deleteStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 380,
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const styleForStatus = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 350, lg: 500 },
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const MachineCenter = ({
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
  getMachineCenter,
  getMachineCenterReducer,
  createMachine,
  updateMachineCenter,
  getDynamicColumnReducer,
  deleteMachine,
  getWorkCenterReducer,
  getLocationsForMachineReducer,
  getDynamicColumn,
  createDynamicColumn,
  getPrintersForLabelCreation,
  getPrintersForLabelCreationReducer,
  getLocationsForMachine,
  getWorkCenter,
  updateMachineStatus,
}) => {
  const theme = createTheme({
    components: {
      MuiSwitch: {
        styleOverrides: {
          switchBase: {
            // Controls default (unchecked) color for the thumb
            color: "white",
          },
          colorPrimary: {
            "&.Mui-checked": {
              // Controls checked color for the thumb
              color: "rgb(25, 118, 210)",
            },
          },
          track: {
            // Controls default (unchecked) color for the track
            opacity: 0.5,
            backgroundColor: "grey",
            ".Mui-checked.Mui-checked + &": {
              // Controls checked color for the track
              opacity: 0.6,
              backgroundColor: "rgb(25, 118, 210)",
            },
          },
        },
      },
    },
  });

  let loginDetails = cookies.get("loginDetailsForWMS");

  let jwtToken = loginDetails?.jwt;

  let roleId = loginDetails?.data?.roleId;
  let dynamicColumnDetails = cookies.get("dynamic-column-data");
  let userId = loginDetails.data.userId;
  let hiddenColumsDetails = cookies.get("hidden-column-data");
  const subModuleId = "b4ed2254-3adb-4048-974b-7cab6ed16497";

  const styleForColumnReorder = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 380,
    color: "black",
    // border: "2px solid #000",
    boxShadow: 24,
    p: 2,
    pt: 3,
  };
  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : []
    );
  }, [getSubModulesByRoleIdReducer]);
  let labelCreation = modulesData.find(
    (moduleId) => moduleId.moduleId == "b4ed2254-3adb-4048-974b-7cab6ed16497"
  );
  let createAccess = labelCreation
    ? labelCreation.actionId.includes("db40049c-8d85-474d-a7a0-5633ae1f3b15")
    : null;
  let viewAccess = labelCreation
    ? labelCreation.actionId.includes("3f1e0a00-53b4-4575-89d7-f9176acb6e53")
    : null;
  let editAccess = labelCreation
    ? labelCreation.actionId.includes("c16e10f9-db3c-45ba-aa58-80321bc17079")
    : null;
  let deleteAccess = labelCreation
    ? labelCreation.actionId.includes("6e6af6b1-6676-4fd0-9409-8fd10564c623")
    : null;

  const [pageNo, setPageNo] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchObject, setSearchObject] = useState(JSON.stringify({}));
  const [paginationObj, setPaginationObj] = useState({});
  const [errorMsgFromApi, setErrorMsgFromApi] = useState("");

  const importPageNo = (pageIndex) => {
    setPageNo(pageIndex === -1 ? pageNo : pageIndex);
  };

  const importRowsPerPage = (pageSize) => {
    setRowsPerPage(pageSize);
  };

  const importSearch = (globalFilter) => {
    setSearchObject(globalFilter ? JSON.stringify(globalFilter) : "");
  };
  const [refresh, setRefresh] = useState("");
  // setTimeout(() => {
  //   setRefresh(!refresh);
  // }, 60000);

  useEffect(() => {
    viewAccess && getMachineCenter(pageNo, rowsPerPage, searchObject, jwtToken);
  }, [viewAccess, pageNo, rowsPerPage, searchObject]);

  useEffect(() => {
    getLocationsForMachine(jwtToken);
  }, []);
  useEffect(() => {
    getWorkCenter(jwtToken);
  }, []);

  const statusOptions = [
    {
      label: "All Status",
      value: "",
    },
    {
      label: "Approved",
      value: 0,
    },
    {
      label: "In Progress",
      value: 3,
    },
    {
      label: "Released",
      value: 2,
    },
    {
      label: "Completed",
      value: 1,
    },
  ];

  const [state, setState] = useState({
    columns: [
      { Header: "Machine Code", accessor: "machineCode" },
      { Header: "Make", accessor: "make" },
      { Header: "Model", accessor: "model" },
      { Header: "Integration Option", accessor: "integrationOption" },
      { Header: "work Center Location Code", accessor: "workLocationCode" },
      { Header: "work Order Code", accessor: "woCode" },
      { Header: "Location", accessor: "MachineLocationCode" },
      {
        Header: "Status",
        accessor: "status",
        align: "left",
        cannotSearch: true,
        cannotSort: true,
      },
      {
        Header: "Created Date",

        accessor: "cd",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value
            ? format(
                addMinutes(
                  new Date(value),
                  new Date(value).getTimezoneOffset()
                ),
                "dd/MM/yyyy hh:mm aaa"
              )
            : "";
        },
      },
      {
        Header: "action",
        accessor: "action",
        align: "center",
        cannotSearch: true,
        cannotSort: true,
      },
    ],
    rows: [],
  });
  const [loading, setLoading] = useState(true);

  const { columns, rows } = state;

  const [openWarehouseStatusModal, setOpenWarehouseStatusModal] =
    useState(false);

  const handleOpenWarehouseStatusModal = () => {
    setOpenWarehouseStatusModal(true);
  };
  const handleCloseWarehouseStatusModal = () => {
    setOpenWarehouseStatusModal(false);
  };

  const [singleWarehouseDate, setSingleWarehouseDate] = useState({});

  const [remark, setRemark] = useState("");
  const [locationId, setLocationId] = useState("");

  const updateStatus = async () => {
    singleWarehouseDate["status"] = !singleWarehouseDate.status;

    let payload = {
      machineCenterId: singleWarehouseDate.machineCenterId,
      isAvailable: !singleWarehouseDate.isAvailable,
      remark: remark,
      userId: userId,
    };

    let res = await updateMachineStatus(payload, jwtToken);

    if (res.status) {
      await getMachineCenter(pageNo, rowsPerPage, searchObject, jwtToken);
      handleCloseWarehouseStatusModal();
    }
  };

  useEffect(() => {
    let tempLabels = [];
    let data = getMachineCenterReducer.labels.data
      ? getMachineCenterReducer.labels.data
      : [];

    setPaginationObj(getMachineCenterReducer?.labels?.pagination);
    setLoading(getMachineCenterReducer.loading);
    data &&
      data[0]?.cd &&
      data.map((label) => {
        const formatDate = new Date(label?.cd);
        const labelObject = {
          machineCode: label.machineCode,
          integrationOption: label.integrationOption,
          workLocationCode: label.workLocationCode,
          make: label.make,
          model: label.model,
          woCode: label.woCode,
          MachineLocationCode: label.MachineLocationCode,
          createdDate: format(
            addMinutes(formatDate, formatDate.getTimezoneOffset()),
            "dd/MM/yyyy hh:mm aaa"
          ),
          cd: label?.cd,
          status: (
            <ThemeProvider theme={theme}>
              <StandardSwitch
                checked={label.isAvailable === 1 ? true : false}
                onChange={() => {
                  handleOpenWarehouseStatusModal();
                  setSingleWarehouseDate(label);
                }}
              />
            </ThemeProvider>
          ),
          action: label.labelId !== 1 && (
            <div>
              {editAccess && (
                <EditButton
                  tooltip="Edit"
                  variant="gradient"
                  color="success"
                  // size="small"
                  iconOnly
                  type="button"
                  onClick={() => {
                    handleOpenUpdateLabelModal(label);
                    setLocationId(label.locationId);
                  }}
                  style={{ marginRight: "5px" }}
                >
                  <Icon>edit_sharp</Icon>
                </EditButton>
              )}

              {deleteAccess && (
                <DeleteButton
                  tooltip="Delete "
                  variant="gradient"
                  color="error"
                  iconOnly
                  // size="small"
                  type="button"
                  style={{ marginRight: "5px" }}
                  onClick={() => handleOpenDeleteLabelModal(label)}
                >
                  <Icon>delete</Icon>
                </DeleteButton>
              )}
            </div>
          ),
        };
        tempLabels.push(labelObject);
      });

    setState({ ...state, rows: tempLabels });
  }, [getMachineCenterReducer]);

  const [assetTypeSelected, setAssetTypeSelected] = useState("");
  const [mrpPrinterSelected, setMrpPrinterSelected] = useState("");

  const [assetTypeForEditSelected, setAssetTypeForEditSelected] = useState("");
  const [mrpPrinterForEditSelected, setMrpPrinterForEditSelected] =
    useState("");
  const [assetTypeOptions, setAssetTypeOptions] = useState([]);

  useEffect(() => {
    let tempAssetTypeOptions = [];
    let data = getPrintersForLabelCreationReducer.printers.data
      ? getPrintersForLabelCreationReducer.printers.data
      : [];

    data.map((asset) => {
      tempAssetTypeOptions.push({
        label: asset.assetName,
        value: asset.assetId,
      });
    });

    setAssetTypeOptions(tempAssetTypeOptions);
  }, [getPrintersForLabelCreationReducer]);

  const handleAssetTypeChange = (selectedZone) => {
    setAssetTypeSelected(selectedZone);
  };

  const handleMrpPrinterChange = (selectedZone) => {
    setMrpPrinterSelected(selectedZone);
  };

  const handleAssetTypeForEditChange = (selectedZone) => {
    setAssetTypeForEditSelected(selectedZone);
  };

  const handleMrpPrinterForEditChange = (selectedZone) => {
    setMrpPrinterForEditSelected(selectedZone);
  };

  const [isErrorCreateLabel, setIsErrorCreateLabel] = useState(false);
  const [isSuccessCreateLabel, setIsSuccessCreateLabel] = useState(false);

  const [openCreateLabelModal, setOpenCreateLabelModal] = useState(false);

  useEffect(() => {
    if (isErrorCreateLabel) {
      setTimeout(() => {
        setIsErrorCreateLabel(false);
      }, 3000);
    }
  }, [isErrorCreateLabel]);

  useEffect(() => {
    if (isSuccessCreateLabel) {
      setTimeout(() => {
        setIsSuccessCreateLabel(false);
      }, 3000);
    }
  }, [isSuccessCreateLabel]);

  const [createdLocationsOptions, setLocationsOptions] = useState([]);

  useEffect(() => {
    let tempCreatedActivityOptions = [];
    let data = getLocationsForMachineReducer.labels.data
      ? getLocationsForMachineReducer.labels.data
      : [];
    data.map((activity) => {
      tempCreatedActivityOptions.push({
        label: activity.locationCode,
        value: activity.locationId,
      });
    });
    setLocationsOptions(tempCreatedActivityOptions);
  }, [getLocationsForMachineReducer]);
  const [workCenterOptions, setWorkCenterOptions] = useState([]);

  useEffect(() => {
    let tempCreatedActivityOptions = [];
    let data = getWorkCenterReducer.labels.data
      ? getWorkCenterReducer.labels.data
      : [];
    data.map((activity) => {
      tempCreatedActivityOptions.push({
        label: activity.woCode,
        value: activity.workCenterId,
      });
    });
    setWorkCenterOptions(tempCreatedActivityOptions);
  }, [getWorkCenterReducer]);

  const handleOpenCreateLabelModal = () => {
    setOpenCreateLabelModal(true);
    getPrintersForLabelCreation(jwtToken);
    formikForCreateLabel.setValues(initialValueForCreateLabel);
    formikForCreateLabel.setTouched({});
    formikForCreateLabel.setErrors({});
    setMovementTypeSelected("");
    setWorkCenterSelected("");
  };

  const handleCloseCreateLabelModal = () => {
    setOpenCreateLabelModal(false);
  };

  const initialValueForCreateLabel = {
    machineCode: "",
    make: "",
    model: "",
    integrationCreate: "",
    locationCreate: "",
  };

  const validationSchema = Yup.object({
    machineCode: Yup.string().required("Enter the Machine code!"),
    make: Yup.string().required("Enter the Make!"),
    model: Yup.string().required("Enter the Model!"),
    integration: Yup.string().required("Enter the Integration!"),
    location: Yup.string().required("Enter the Location!"),
  });

  const [errorMsgForCreate, setErrorMsgForCreate] = useState("");

  const [buttonName, setButtonName] = useState("Create");

  const onSubmitForCreateLabel = async (values, { resetForm }) => {
    let payload = {
      machineCode: values.machineCode,
      locationId: movementTypeSelected?.value,
      make: values.make,
      model: values.model,
      integrationOption: values.integrationCreate,
      workCenterId: workCenterSelected?.value,
      // userId: userId,
    };
    setButtonName("Please wait...");
    let res = await createMachine(payload, jwtToken);

    if (res.status) {
      setIsSuccessCreateLabel(true);
      getMachineCenter(pageNo, rowsPerPage, searchObject, jwtToken);

      setTimeout(() => {
        handleCloseCreateLabelModal();
        setButtonName("Create ");
      }, 2250);

      resetForm();
    }
    if (!res.status) {
      setErrorMsgForCreate(res?.data?.data?.msg);
      setIsErrorCreateLabel(true);
      setButtonName("Create ");
    }
  };

  const formikForCreateLabel = useFormik({
    initialValues: initialValueForCreateLabel,
    // validationSchema: validationSchema,
    onSubmit: onSubmitForCreateLabel,
  });

  const [singleLabelDataForDelete, setSingleLabelDataForDelete] = useState({});
  const [openDeleteLabelModal, setOpenDeleteLabelModal] = useState(false);

  const handleOpenDeleteLabelModal = (data = {}) => {
    setSingleLabelDataForDelete(data);
    setOpenDeleteLabelModal(true);
  };
  const handleCloseDeleteLabelModal = () => {
    setOpenDeleteLabelModal(false);
  };

  const [isErrorDeleteLabel, setIsErrorDeleteLabel] = useState(false);
  const [isSuccessDeleteLabel, setIsSuccessDeleteLabel] = useState(false);

  useEffect(() => {
    if (isErrorDeleteLabel) {
      setTimeout(() => {
        setIsErrorDeleteLabel(false);
      }, 3000);
    }
  }, [isErrorDeleteLabel]);

  useEffect(() => {
    if (isSuccessDeleteLabel) {
      setTimeout(() => {
        setIsSuccessDeleteLabel(false);
      }, 3000);
    }
  }, [isSuccessDeleteLabel]);

  const [errorMsgForDelete, setErrorMsgForDelete] = useState("");
  const [deleteButtonName, setDeleteButtonName] = useState("Delete");

  const [movementTypeSelected, setMovementTypeSelected] = useState("");

  const handleChangeMovementType = (selectedOption) => {
    setMovementTypeSelected(selectedOption);
  };
  const [workCenterSelected, setWorkCenterSelected] = useState("");

  const handleChangeWorkCenterType = (selectedOption) => {
    setWorkCenterSelected(selectedOption);
  };

  const deleteLabelHandler = async () => {
    setDeleteButtonName("Please wait...");
    let machineCenterId = singleLabelDataForDelete.machineCenterId;
    let response = await deleteMachine(machineCenterId, jwtToken);

    if (response.status) {
      setIsSuccessDeleteLabel(true);
      getMachineCenter(pageNo, rowsPerPage, searchObject, jwtToken);

      setTimeout(() => {
        handleCloseDeleteLabelModal();
        setDeleteButtonName("Delete");
      }, 2250);
    }
    if (!response.status) {
      setErrorMsgForDelete(response?.data?.data?.msg);
      setIsErrorDeleteLabel(true);
      setDeleteButtonName("Delete");
    }
  };

  const [openUpdateLabelModal, setOpenUpdateLabelModal] = useState(false);
  const [singleLabelDataForUpdate, setLabelDataForUpdate] = useState({});

  const [controlTypeSelectedForEdit, setControlTypeSelectedForEdit] =
    useState("");

  const handleChangeControlTypeForEdit = (selectedOption) => {
    setControlTypeSelectedForEdit(selectedOption);
  };

  const [locationSelectedForEdit, setLocationSelectedForEdit] = useState("");

  const handleChangeLocationForEdit = (selectedOption) => {
    setLocationSelectedForEdit(selectedOption);
  };
  const handleOpenUpdateLabelModal = (data = {}) => {
    setLabelDataForUpdate(data);
    setControlTypeSelectedForEdit({
      label: data?.woCode,
      value: data?.workCenterId,
    });
    setLocationSelectedForEdit({
      label: data?.MachineLocationCode,
      value: data?.suidPrinterIpId,
    });
    setMrpPrinterForEditSelected({
      label: data?.mrpAssetName,
      value: data?.mrpPrinterIpId,
    });
    setOpenUpdateLabelModal(true);
    setIsErrorForUpdate(false);
    setIsSuccessForUpdate(false);
    getPrintersForLabelCreation(jwtToken);
  };

  const handleCloseUpdateLabelModal = () => {
    setOpenUpdateLabelModal(false);
    formikForUpdate.setErrors({});
  };

  const [isErrorForUpdate, setIsErrorForUpdate] = useState(false);
  const [isSuccessForUpdate, setIsSuccessForUpdate] = useState(false);

  useEffect(() => {
    if (isErrorForUpdate) {
      setTimeout(() => {
        setIsErrorForUpdate(false);
      }, 3000);
    }
  }, [isErrorForUpdate]);

  useEffect(() => {
    if (isSuccessForUpdate) {
      setTimeout(() => {
        setIsSuccessForUpdate(false);
      }, 3000);
    }
  }, [isSuccessForUpdate]);

  const initialValueForUpdate = {
    // workCenterId: singleLabelDataForUpdate.workCenterId,
    machineCode: singleLabelDataForUpdate.machineCode,
    make: singleLabelDataForUpdate.make,
    model: singleLabelDataForUpdate.model,
    // woCode: singleLabelDataForUpdate.workLocationCode,
    intergrationOptionForCreate: singleLabelDataForUpdate.integrationOption,
    // suidPrinterIpId: singleLabelDataForUpdate.suidPrinterIpId,
    // mrpPrinterIpId: singleLabelDataForUpdate.mrpPrinterIpId,
  };

  const validationSchemaForUpdate = Yup.object({
    machineCode: Yup.string().required("Enter the Machine code!"),
    make: Yup.string().required("Enter the Make!"),
    model: Yup.string().required("Enter the Model!"),
    woCode: Yup.string().required("Enter the woCode!"),
    location: Yup.string().required("Enter the Location!"),
  });

  const [errorMsgForUpdate, setErrorMsgForUpdate] = useState("");

  const [editButtonName, setEditButtonName] = useState("Submit");

  const onSubmitForUpdate = async (values) => {
    setEditButtonName("Please wait...");
    let payload = {
      machineCode: values.machineCode,
      make: values.make,
      model: values.model,
      integrationOption: values.intergrationOptionForCreate,
      workCenterId: controlTypeSelectedForEdit?.value,
      locationId: locationSelectedForEdit?.value,
      machineCenterId: singleLabelDataForUpdate.machineCenterId,
      // workCenterId: singleLabelDataForUpdate.workCenterId,
      // userId: userId,
      locationId: locationId,
    };
    let res = await updateMachineCenter(payload, jwtToken);
    if (res.status) {
      setIsSuccessForUpdate(true);
      getMachineCenter(pageNo, rowsPerPage, searchObject, jwtToken);
      setTimeout(() => {
        setEditButtonName("Submit");
        handleCloseUpdateLabelModal();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorForUpdate(true);
      setErrorMsgForUpdate(res?.data?.data?.msg);
      setEditButtonName("Submit");
    }
  };

  const formikForUpdate = useFormik({
    initialValues: initialValueForUpdate,
    onSubmit: onSubmitForUpdate,
    // validationSchema: validationSchemaForUpdate,
    enableReinitialize: true,
  });

  useEffect(() => {
    getDynamicColumn(userId, subModuleId, jwtToken);
  }, [userId, subModuleId]);

  const [loadingForDynamicColumn, setLoadingForDynamicColumn] = useState(false);
  useEffect(() => {
    let data = getDynamicColumnReducer.dynamicColumn.data
      ? getDynamicColumnReducer.dynamicColumn.data
      : [];

    setDynamicColumnData(data);
    cookies.set("hidden-column-data", JSON.stringify(data?.notVisibleFields), {
      path: "/",
    });

    setTimeout(() => {
      setLoadingForDynamicColumn(true);
    }, 1000);
  }, [getDynamicColumnReducer, loading]);

  const [openCreateColumnReorderModal, setOpenCreateColumnReorderModal] =
    useState(false);

  const handleOpenCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(true);
  };

  const handleCloseCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(false);
  };

  const [dynamicColumnData, setDynamicColumnData] = useState("");
  const [isErrorColumnReorder, setIsErrorColumnReorder] = useState(false);
  const [isSuccessColumnReorder, setIsSuccessColumnReorder] = useState(false);

  useEffect(() => {
    if (isErrorColumnReorder) {
      setTimeout(() => {
        setIsErrorColumnReorder(false);
      }, 3000);
    }
  }, [isErrorColumnReorder]);

  useEffect(() => {
    if (isSuccessColumnReorder) {
      setTimeout(() => {
        setIsSuccessColumnReorder(false);
      }, 3000);
    }
  }, [isSuccessColumnReorder]);

  const [isErrorMsgForColumnReorder, setIsErrorMsgForColumnReorder] =
    useState(false);

  const handleDynamicColumn = async () => {
    let res = await createDynamicColumn(dynamicColumnDetails, jwtToken);
    if (res.status) {
      setIsSuccessColumnReorder(true);
      getDynamicColumn(userId, subModuleId, jwtToken);

      getMachineCenter(pageNo, rowsPerPage, searchObject, jwtToken);
      setTimeout(() => {
        handleCloseCreateColumnReorderModal();
        // window.location.reload();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorColumnReorder(true);
      setIsErrorMsgForColumnReorder(res?.data?.data?.msg);
    }
  };
  return (
    <div>
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox pt={0} pb={3} mb={-2.5}>
          <Grid container spacing={6}>
            <Grid item xs={12}>
              <Card>
                <MDBox color="text" p={0} px={2} mt={0} mb={-2}>
                  {createAccess ? (
                    <MDBox color="text" px={2} ml={-2} mb={1}>
                      <CreateButton
                        tooltip="Create"
                        color="info"
                        variant="contained"
                        type="button"
                        onClick={handleOpenCreateLabelModal}
                        style={{ marginRight: "10px" }}
                        // size="small"
                        iconOnly
                      >
                        <Icon>add</Icon>
                      </CreateButton>
                    </MDBox>
                  ) : (
                    <MDBox color="text" px={2} ml={-2} mb={1}>
                      <CreateButton
                        tooltip="Create"
                        disabled
                        color="info"
                        variant="contained"
                        type="button"
                        onClick={handleOpenCreateLabelModal}
                        style={{ marginRight: "10px" }}
                        // size="small"
                        iconOnly
                      >
                        <Icon>add</Icon>
                      </CreateButton>
                    </MDBox>
                  )}
                </MDBox>

                <MDBox pt={3}>
                  {loadingForDynamicColumn && (
                    <DataTable
                      table={{ columns, rows }}
                      isSorted={true}
                      tableSearch={true}
                      entriesPerPage={{
                        defaultValue: 5,
                        entries: [5, 10, 15, 20, 25, 30],
                      }}
                      showTotalEntries={true}
                      noEndBorder
                      options={{ draggable: false }}
                      serverSidePagination={true}
                      paginationObj={paginationObj}
                      pageNoValue={pageNo}
                      rowsPerPageValue={rowsPerPage}
                      pageNoProp={importPageNo}
                      rowsPerPageProp={importRowsPerPage}
                      searchProp={importSearch}
                      loading={loading}
                      hideColumns={hiddenColumsDetails}
                      visibleColumns2={dynamicColumnData?.visibleFields}
                      dynamicColumnData={dynamicColumnData}
                      handleOpenCreateColumnReorderModal={
                        handleOpenCreateColumnReorderModal
                      }
                      subModuleId={subModuleId}
                      userId={userId}
                    />
                  )}
                </MDBox>
                <Modal
                  open={openCreateLabelModal}
                  onClose={handleCloseCreateLabelModal}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <MDCard sx={style}>
                    <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                      <MDTypography
                        variant="h4"
                        fontWeight="medium"
                        flexGrow={1}
                      >
                        Create
                      </MDTypography>
                      <Tooltip title="Close">
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          onClick={handleCloseCreateLabelModal}
                          sx={{
                            background: "whitesmoke",
                            color: "black",
                            borderRadius: 1,
                            ml: -6,
                          }}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </MDBox>

                    <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                    <MDBox pt={1} pb={3} px={3}>
                      <MDBox
                        component="form"
                        onSubmit={formikForCreateLabel.handleSubmit}
                      >
                        {/* ✅ Use Grid to align fields horizontally */}
                        <Grid container spacing={2}>
                          {/* Column 1 */}
                          <Grid item xs={12} sm={6}>
                            <MDBox mb={2}>
                              <MDTypography variant="h6" fontWeight="medium">
                                Machine Code
                              </MDTypography>
                              <MDInput
                                type="text"
                                name="machineCode"
                                fullWidth
                                onBlur={formikForCreateLabel.handleBlur}
                                onChange={formikForCreateLabel.handleChange}
                                value={formikForCreateLabel.values.machineCode}
                                error={
                                  formikForCreateLabel.touched.machineCode &&
                                  Boolean(
                                    formikForCreateLabel.errors.machineCode
                                  )
                                }
                                inputProps={{ maxLength: 45 }}
                              />
                              {formikForCreateLabel.errors.machineCode &&
                                formikForCreateLabel.touched.machineCode && (
                                  <TextError
                                    msg={
                                      formikForCreateLabel.errors.machineCode
                                    }
                                  />
                                )}
                            </MDBox>

                            <MDBox mb={2}>
                              <MDTypography variant="h6" fontWeight="medium">
                                Model
                              </MDTypography>
                              <MDInput
                                type="text"
                                name="model"
                                fullWidth
                                onBlur={formikForCreateLabel.handleBlur}
                                onChange={formikForCreateLabel.handleChange}
                                value={formikForCreateLabel.values.model}
                                error={
                                  formikForCreateLabel.touched.model &&
                                  Boolean(formikForCreateLabel.errors.model)
                                }
                                inputProps={{ maxLength: 45 }}
                              />
                              {formikForCreateLabel.errors.model &&
                                formikForCreateLabel.touched.model && (
                                  <TextError
                                    msg={formikForCreateLabel.errors.model}
                                  />
                                )}
                            </MDBox>

                            <MDBox mb={2}>
                              <MDTypography variant="h6" fontWeight="medium">
                                Location
                              </MDTypography>
                              <Select
                                isClearable
                                className="select-css"
                                maxMenuHeight={130}
                                placeholder="Choose one..."
                                name="locationCreate"
                                value={movementTypeSelected}
                                options={createdLocationsOptions}
                                onBlur={formikForCreateLabel.handleBlur}
                                onChange={(selectedOption) => {
                                  handleChangeMovementType(selectedOption);
                                  formikForCreateLabel.setFieldValue(
                                    "locationCreate",
                                    selectedOption
                                  );
                                }}
                              />
                              {formikForCreateLabel.touched.locationCreate &&
                                formikForCreateLabel.errors.locationCreate && (
                                  <TextError
                                    msg={
                                      formikForCreateLabel.errors.locationCreate
                                    }
                                  />
                                )}
                            </MDBox>
                          </Grid>

                          {/* Column 2 */}
                          <Grid item xs={12} sm={6}>
                            <MDBox mb={2}>
                              <MDTypography variant="h6" fontWeight="medium">
                                Make
                              </MDTypography>
                              <MDInput
                                type="text"
                                name="make"
                                fullWidth
                                onBlur={formikForCreateLabel.handleBlur}
                                onChange={formikForCreateLabel.handleChange}
                                value={formikForCreateLabel.values.make}
                                error={
                                  formikForCreateLabel.touched.make &&
                                  Boolean(formikForCreateLabel.errors.make)
                                }
                                inputProps={{ maxLength: 45 }}
                              />
                              {formikForCreateLabel.errors.make &&
                                formikForCreateLabel.touched.make && (
                                  <TextError
                                    msg={formikForCreateLabel.errors.make}
                                  />
                                )}
                            </MDBox>

                            <MDBox mb={2}>
                              <MDTypography variant="h6" fontWeight="medium">
                                Integration Option
                              </MDTypography>
                              <MDInput
                                type="text"
                                name="integrationCreate"
                                fullWidth
                                onBlur={formikForCreateLabel.handleBlur}
                                onChange={formikForCreateLabel.handleChange}
                                value={
                                  formikForCreateLabel.values.integrationCreate
                                }
                                error={
                                  formikForCreateLabel.touched
                                    .integrationCreate &&
                                  Boolean(
                                    formikForCreateLabel.errors
                                      .integrationCreate
                                  )
                                }
                                inputProps={{ maxLength: 45 }}
                              />
                              {formikForCreateLabel.errors.integrationCreate &&
                                formikForCreateLabel.touched
                                  .integrationCreate && (
                                  <TextError
                                    msg={
                                      formikForCreateLabel.errors
                                        .integrationCreate
                                    }
                                  />
                                )}
                            </MDBox>

                            <MDBox mb={2}>
                              <MDTypography variant="h6" fontWeight="medium">
                                Work Center
                              </MDTypography>
                              <Select
                                isClearable
                                className="select-css"
                                maxMenuHeight={130}
                                placeholder="Choose one..."
                                name="workOrder"
                                value={workCenterSelected}
                                options={workCenterOptions}
                                onBlur={formikForCreateLabel.handleBlur}
                                onChange={(selectedOption) => {
                                  handleChangeWorkCenterType(selectedOption);
                                  formikForCreateLabel.setFieldValue(
                                    "workOrder",
                                    selectedOption
                                  );
                                }}
                              />
                              {formikForCreateLabel.touched.workOrder &&
                                formikForCreateLabel.errors.workOrder && (
                                  <TextError
                                    msg={formikForCreateLabel.errors.workOrder}
                                  />
                                )}
                            </MDBox>
                          </Grid>
                        </Grid>

                        {/* Alerts and Submit */}
                        <MDBox mt={2}>
                          <Collapse in={isSuccessCreateLabel}>
                            <Alert
                              severity="success"
                              action={
                                <IconButton
                                  aria-label="close"
                                  color="inherit"
                                  size="small"
                                  onClick={() => setIsSuccessCreateLabel(false)}
                                >
                                  <CloseIcon fontSize="inherit" />
                                </IconButton>
                              }
                            >
                              Created successfully!
                            </Alert>
                          </Collapse>

                          <Collapse in={isErrorCreateLabel}>
                            <Alert
                              severity="error"
                              action={
                                <IconButton
                                  aria-label="close"
                                  color="inherit"
                                  size="small"
                                  onClick={() => setIsErrorCreateLabel(false)}
                                >
                                  <CloseIcon fontSize="inherit" />
                                </IconButton>
                              }
                            >
                              {errorMsgForCreate}
                            </Alert>
                          </Collapse>
                        </MDBox>

                        <MDBox mt={3}>
                          <MDButton
                            type="submit"
                            variant="gradient"
                            color="info"
                            fullWidth
                            disabled={buttonName === "Please wait..."}
                          >
                            {buttonName}
                          </MDButton>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                  </MDCard>
                </Modal>

                <Modal
                  open={openUpdateLabelModal}
                  onClose={handleCloseUpdateLabelModal}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <MDCard sx={style}>
                    <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                      <MDTypography
                        variant="h4"
                        fontWeight="medium"
                        flexGrow={1}
                      >
                        Edit
                      </MDTypography>
                      <MDBox>
                        <Tooltip title="Close">
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            onClick={handleCloseUpdateLabelModal}
                            style={{
                              background: "whitesmoke",
                              color: "black",
                              borderRadius: 5,
                              marginLeft: "-55px",
                            }}
                          >
                            <CloseIcon />
                          </IconButton>
                        </Tooltip>
                      </MDBox>
                    </MDBox>
                    <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                    <MDBox pt={1} pb={3} px={3}>
                      <MDBox
                        component="form"
                        role="form"
                        onSubmit={formikForUpdate.handleSubmit}
                      >
                        <MDBox mb={2}>
                          <MDTypography variant="h6">Machine Code</MDTypography>
                          <MDInput
                            type="text"
                            name="machineCode"
                            fullWidth
                            autoComplete="off"
                            onBlur={formikForUpdate.handleBlur}
                            onChange={formikForUpdate.handleChange}
                            value={formikForUpdate.values.machineCode}
                            error={
                              formikForUpdate.touched.machineCode &&
                              formikForUpdate.errors.machineCode &&
                              true
                            }
                            inputProps={{
                              maxLength: 45,
                            }}
                          />
                          {formikForUpdate.touched.machineCode &&
                            formikForUpdate.errors.machineCode && (
                              <TextError
                                msg={formikForUpdate.errors.machineCode}
                              />
                            )}
                        </MDBox>
                        <MDBox mb={2}>
                          <MDTypography variant="h6">Make</MDTypography>
                          <MDInput
                            type="text"
                            name="make"
                            fullWidth
                            autoComplete="off"
                            onBlur={formikForUpdate.handleBlur}
                            onChange={formikForUpdate.handleChange}
                            value={formikForUpdate.values.make}
                            error={
                              formikForUpdate.touched.make &&
                              formikForUpdate.errors.make &&
                              true
                            }
                            inputProps={{
                              maxLength: 45,
                            }}
                          />
                          {formikForUpdate.touched.make &&
                            formikForUpdate.errors.make && (
                              <TextError msg={formikForUpdate.errors.make} />
                            )}
                        </MDBox>
                        <MDBox mb={2}>
                          <MDTypography variant="h6">Model</MDTypography>
                          <MDInput
                            type="text"
                            name="model"
                            fullWidth
                            autoComplete="off"
                            onBlur={formikForUpdate.handleBlur}
                            onChange={formikForUpdate.handleChange}
                            value={formikForUpdate.values.model}
                            error={
                              formikForUpdate.touched.model &&
                              formikForUpdate.errors.model &&
                              true
                            }
                            inputProps={{
                              maxLength: 45,
                            }}
                          />
                          {formikForUpdate.touched.model &&
                            formikForUpdate.errors.model && (
                              <TextError msg={formikForUpdate.errors.model} />
                            )}
                        </MDBox>
                        <MDBox mb={2}>
                          <MDTypography variant="h6">
                            Integration Option
                          </MDTypography>
                          <MDInput
                            type="text"
                            name="intergrationOptionForCreate"
                            fullWidth
                            autoComplete="off"
                            onBlur={formikForUpdate.handleBlur}
                            onChange={formikForUpdate.handleChange}
                            value={
                              formikForUpdate.values.intergrationOptionForCreate
                            }
                            error={
                              formikForUpdate.touched
                                .intergrationOptionForCreate &&
                              formikForUpdate.errors
                                .intergrationOptionForCreate &&
                              true
                            }
                            inputProps={{
                              maxLength: 45,
                            }}
                          />
                          {formikForUpdate.touched
                            .intergrationOptionForCreate &&
                            formikForUpdate.errors
                              .intergrationOptionForCreate && (
                              <TextError
                                msg={
                                  formikForUpdate.errors
                                    .intergrationOptionForCreate
                                }
                              />
                            )}
                        </MDBox>
                        <MDBox mb={2}>
                          <MDTypography
                            variant="h6"
                            fontWeight="medium"
                            style={{ fontWeight: "500" }}
                          >
                            Work Center
                          </MDTypography>

                          <Select
                            isClearable
                            className="select-css"
                            maxMenuHeight={130}
                            placeholder="Choose one..."
                            name="workCenter"
                            value={controlTypeSelectedForEdit}
                            options={workCenterOptions}
                            onChange={(selectedOption) => {
                              handleChangeControlTypeForEdit(selectedOption);
                              formikForUpdate.setFieldValue(
                                "workCenter",
                                selectedOption
                              );
                            }}
                          />
                          {formikForUpdate.errors.workCenter && (
                            <TextError
                              msg={formikForUpdate.errors.workCenter}
                            />
                          )}
                        </MDBox>
                        <MDBox mb={2}>
                          <MDTypography
                            variant="h6"
                            fontWeight="medium"
                            style={{ fontWeight: "500" }}
                          >
                            Location
                          </MDTypography>

                          <Select
                            isClearable
                            className="select-css"
                            maxMenuHeight={130}
                            placeholder="Choose one..."
                            name="location"
                            value={locationSelectedForEdit}
                            options={createdLocationsOptions}
                            onChange={(selectedOption) => {
                              handleChangeLocationForEdit(selectedOption);
                              formikForUpdate.setFieldValue(
                                "location",
                                selectedOption
                              );
                            }}
                          />
                          {formikForUpdate.errors.location && (
                            <TextError msg={formikForUpdate.errors.location} />
                          )}
                        </MDBox>
                        {/* 
                        <MDBox mb={2}>
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: 500 }}
                          >
                            SUID Printer
                          </MDTypography>

                          <Select
                            isClearable
                            className="select-css"
                            maxMenuHeight={180}
                            placeholder="Select ..."
                            name="suidPrinterIpId"
                            value={assetTypeForEditSelected}
                            options={assetTypeOptions}
                            onChange={(selectedOption) => {
                              handleAssetTypeForEditChange(selectedOption);
                              formikForUpdate.setFieldValue(
                                "suidPrinterIpId",
                                selectedOption
                              );
                            }}
                          />
                          {formikForUpdate.errors.suidPrinterIpId && (
                            <TextError
                              msg={formikForUpdate.errors.suidPrinterIpId}
                            />
                          )}
                        </MDBox>

                        <MDBox mb={2}>
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: 500 }}
                          >
                            MRP Printer
                          </MDTypography>

                          <Select
                            isClearable
                            className="select-css"
                            maxMenuHeight={180}
                            placeholder="Select ..."
                            name="mrpPrinterIpId"
                            value={mrpPrinterForEditSelected}
                            options={assetTypeOptions}
                            onChange={(selectedOption) => {
                              handleMrpPrinterForEditChange(selectedOption);
                              formikForUpdate.setFieldValue(
                                "mrpPrinterIpId",
                                selectedOption
                              );
                            }}
                          />
                          {formikForUpdate.errors.mrpPrinterIpId && (
                            <TextError
                              msg={formikForUpdate.errors.mrpPrinterIpId}
                            />
                          )}
                        </MDBox> */}

                        <MDBox>
                          <Collapse in={isErrorForUpdate}>
                            <Alert
                              severity="error"
                              action={
                                <IconButton
                                  aria-label="close"
                                  color="inherit"
                                  size="small"
                                  onClick={() => {
                                    setIsErrorForUpdate(false);
                                  }}
                                >
                                  <CloseIcon fontSize="inherit" />
                                </IconButton>
                              }
                            >
                              {errorMsgForUpdate}
                            </Alert>
                          </Collapse>
                          <Collapse in={isSuccessForUpdate}>
                            <Alert
                              severity="success"
                              action={
                                <IconButton
                                  aria-label="close"
                                  color="inherit"
                                  size="small"
                                  onClick={() => {
                                    setIsErrorForUpdate(false);
                                  }}
                                >
                                  <CloseIcon fontSize="inherit" />
                                </IconButton>
                              }
                            >
                              Updated successfully!
                            </Alert>
                          </Collapse>
                        </MDBox>
                        <MDBox mt={3}>
                          <MDButton
                            variant="contained"
                            color="success"
                            fullWidth
                            type="submit"
                            disabled={editButtonName === "Please wait..."}
                          >
                            {editButtonName}
                          </MDButton>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                  </MDCard>
                </Modal>
                <Modal
                  open={openDeleteLabelModal}
                  onClose={handleCloseDeleteLabelModal}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <MDCard sx={deleteStyle}>
                    <MDTypography>
                      Are you sure you want to delete?
                    </MDTypography>
                    <MDBox mt={2} display="flex">
                      <div>
                        <MDButton
                          style={{ width: "100%", marginRight: "0.5rem" }}
                          color="info"
                          variant="outlined"
                          onClick={handleCloseDeleteLabelModal}
                        >
                          Cancel
                        </MDButton>
                      </div>
                      <div style={{ float: "right" }}>
                        <MDButton
                          style={{ width: "100%", marginLeft: "0.5rem" }}
                          color="error"
                          onClick={deleteLabelHandler}
                          disabled={deleteButtonName === "Please wait..."}
                        >
                          {deleteButtonName}
                        </MDButton>
                      </div>
                    </MDBox>
                    <MDBox mt={2}>
                      <Collapse in={isSuccessDeleteLabel}>
                        <Alert
                          severity="success"
                          action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                setIsSuccessDeleteLabel(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        >
                          Deleted successfully!
                        </Alert>
                      </Collapse>
                      <Collapse in={isErrorDeleteLabel}>
                        <Alert
                          severity="error"
                          action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                setIsErrorDeleteLabel(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        >
                          {errorMsgForDelete}
                        </Alert>
                      </Collapse>
                    </MDBox>
                  </MDCard>
                </Modal>
                <Modal
                  open={openWarehouseStatusModal}
                  onClose={handleCloseWarehouseStatusModal}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <MDCard sx={styleForStatus}>
                    <MDTypography>
                      Are you sure you want to change the status?
                    </MDTypography>
                    <MDBox mt={2} mb={2}>
                      <MDTypography variant="h6">Remark</MDTypography>
                      <MDInput
                        type="text"
                        name="remark"
                        multiline
                        rows={3}
                        fullWidth
                        autoComplete="off"
                        onChange={(e) => setRemark(e.target.value)}
                        value={remark}
                        inputProps={{
                          maxLength: 45,
                        }}
                      />
                    </MDBox>
                    <MDBox mt={2}>
                      <MDButton
                        style={{
                          width: { xs: "100%", lg: "48%" },
                          marginRight: { xs: "10px", lg: "0.5rem" },
                        }}
                        color="info"
                        variant="outlined"
                        onClick={handleCloseWarehouseStatusModal}
                      >
                        Cancel
                      </MDButton>
                      <MDButton
                        style={{
                          width: { xs: "100%", lg: "48%" },
                          marginLeft: "1rem",
                        }}
                        color="success"
                        onClick={updateStatus}
                      >
                        Yes
                      </MDButton>
                    </MDBox>
                  </MDCard>
                </Modal>
                <Modal
                  open={openCreateColumnReorderModal}
                  onClose={handleCloseCreateColumnReorderModal}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <MDCard sx={styleForColumnReorder}>
                    <MDTypography>
                      Are you sure you want to submit?
                    </MDTypography>
                    <MDBox mt={2}>
                      <MDButton
                        style={{ width: "10rem", marginRight: "0.5rem" }}
                        color="info"
                        variant="outlined"
                        onClick={handleCloseCreateColumnReorderModal}
                      >
                        Cancel
                      </MDButton>
                      <MDButton
                        style={{ width: "10rem", marginLeft: "0.5rem" }}
                        color="success"
                        onClick={handleDynamicColumn}
                      >
                        Submit
                      </MDButton>
                    </MDBox>
                    <MDBox mt={2}>
                      <Collapse in={isSuccessColumnReorder}>
                        <Alert
                          severity="success"
                          action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                setIsSuccessColumnReorder(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        >
                          Data updated successfully!
                        </Alert>
                      </Collapse>
                      <Collapse in={isErrorColumnReorder}>
                        <Alert
                          severity="error"
                          action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                setIsErrorColumnReorder(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        >
                          {isErrorMsgForColumnReorder}
                        </Alert>
                      </Collapse>
                    </MDBox>
                  </MDCard>
                </Modal>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
        {loading && (
          <Backdrop
            sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        )}
        <ToastContainer />
        <Footer />
      </DashboardLayout>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    getMachineCenterReducer: state.getMachineCenterReducer,
    getPrintersForLabelCreationReducer:
      state.getPrintersForLabelCreationReducer,
    getDynamicColumnReducer: state.getDynamicColumnReducer,
    getWorkCenterReducer: state.getWorkCenterReducer,
    getLocationsForMachineReducer: state.getLocationsForMachineReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    getMachineCenter: (pageNo, rowsPerPage, searchObject, jwtToken) =>
      dispatch(getMachineCenter(pageNo, rowsPerPage, searchObject, jwtToken)),
    getPrintersForLabelCreation: (jwtToken) =>
      dispatch(getPrintersForLabelCreation(jwtToken)),
    getLocationsForMachine: (jwtToken) =>
      dispatch(getLocationsForMachine(jwtToken)),
    getWorkCenter: (jwtToken) => dispatch(getWorkCenter(jwtToken)),
    createMachine: (payload, jwtToken) =>
      dispatch(createMachine(payload, jwtToken)),
    updateMachineCenter: (payload, jwtToken) =>
      dispatch(updateMachineCenter(payload, jwtToken)),
    deleteMachine: (id, userId, jwtToken) =>
      dispatch(deleteMachine(id, userId, jwtToken)),
    updateMachineStatus: (payload, jwtToken) =>
      dispatch(updateMachineStatus(payload, jwtToken)),
    getDynamicColumn: (userId, subModuleId, jwtToken) =>
      dispatch(getDynamicColumn(userId, subModuleId, jwtToken)),
    createDynamicColumn: (payload, jwtToken) =>
      dispatch(createDynamicColumn(payload, jwtToken)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MachineCenter);
